import { themeVars } from '../theme/vars.ts';
import { space } from '../tokens.ts';
import { style } from '../layer.css';

export const avatarEditorContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  width: 'fit-content',
});

export const sliderContainer = style({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: space.s16,
  color: themeVars.container.foreground.tertiary,
});

export const avatarEditorSlider = style({
  width: '100%',
  transform: `translateY(6px)`,
});
